import { normalizedTrackingStatusMessages } from '@/parcels/constants'

export const getNormalizedTrackingStatusOptions = () => {
  return Object.values(normalizedTrackingStatusMessages).flatMap(group =>
    Object.entries(group).map(([value, label]) => ({ value, label }))
  )
}
